export default function genererContratNature() {
  return {
    libelle: '',
  };
}
